<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             @open="handleOpen"
             @close="clickClose"
             width="840px">
        <div class="row" v-loading="loading">
            <div class="col-12 col-md-4">
                <x-date-picker v-model="form.date_of_issue"
                               type="datetime"
                               label="Fecha de operación"></x-date-picker>
            </div>
            <div class="col-12 col-md-4">
                <x-select v-model="form.inventory_transaction_id"
                          label="Motivo"
                          :options="inventory_transactions"></x-select>
            </div>
            <div class="col-12 col-md-4">
                <x-select v-model="form.warehouse_id"
                          label="Almacén"
                          :options="warehouses"
                          @input="changeWarehouse"></x-select>
            </div>
            <div class="col-md-12">
                <x-input v-model="form.observations"
                         label="Observaciones"
                         type="textarea"></x-input>
            </div>
            <div class="col-12">Productos</div>
            <div class="col-12">
                <x-input-item-search :warehouse-id="form.warehouse_id"
                                     @select="selectItem"></x-input-item-search>
            </div>
            <div class="col-md-12">
                <table class="table table-sm table-hover">
                    <thead>
                    <tr>
                        <th class="text-center" style="width: 32px"></th>
                        <th class="text-left">Nombre</th>
                        <th class="text-right" style="width: 100px">Cantidad</th>
                        <th class="text-right" style="width: 32px"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="it in form.items">
                        <td class="text-center"><img :src="it.image"
                                                     style="max-height: 32px; max-width: 32px; margin-right: 8px"/></td>
                        <td class="text-left">
                            <div>{{ it.name }}</div>
                            <div v-if="it.information">{{ it.information }}</div>
                        </td>
                        <td class="text-right">
                            <x-input v-model="it.stock_add"></x-input>
                        </td>
                        <td class="text-right">

                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-md-12 btn-actions">
                <x-button-cancel @click="clickClose"></x-button-cancel>
                <x-button-submit @click="onSubmit"></x-button-submit>
            </div>
        </div>
    </x-modal>
</template>

<script>

import XButtonCancel from "../../../../components/Form/XButtonCancel";
import XButtonSubmit from "../../../../components/Form/XButtonSubmit";
import XModal from "../../../../components/XModal";
import XInput from "../../../../components/Form/XInput.vue";
import XSelect from "../../../../components/Form/XSelect.vue";
import XDatePicker from "../../../../components/Form/XDatePicker.vue";
import XInputItemSearch from "../../../../components/Form/XInputItemSearch.vue";

export default {
    name: 'InventoryGuideForm',
    components: {XInputItemSearch, XDatePicker, XSelect, XInput, XModal, XButtonSubmit, XButtonCancel},
    props: {
        showDialog: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            title: null,
            loading: false,
            resource: 'inventory/guides',
            errors: {},
            form: {},
            itemSelect: '',
            inventory_transactions: [],
            warehouses: []
        }
    },
    created() {
        this.initForm();
        this.initTables();
    },
    methods: {
        initForm() {
            this.title = '';
            this.errors = {};
            this.form = {
                id: null,
                date_of_issue: moment().format('YYYY-MM-DD HH:mm:ss'),
                inventory_transaction_id: '99',
                establishment_id: null,
                warehouse_id: null,
                warehouse_id_initial: null,
                observations: null,
                items: []
            }
        },
        async initTables() {
            await this.$http.get(`/${this.resource}/tables`)
                .then(response => {
                    this.inventory_transactions = response.data.inventory_transactions;
                    this.warehouses = response.data.warehouses;
                });
        },
        handleOpen() {
            this.initForm();
            this.title = 'Nueva guía de entrada y salida';
            this.form.warehouse_id = _.head(this.warehouses).id;
            this.form.warehouse_id_initial = this.form.warehouse_id;
        },
        async searchItem(input, cb) {
            let items = [];
            await this.$http.post(`/store/get_items`, {
                'input': input,
                'warehouse_id': this.form.warehouse_id
            })
                .then(response => {
                    items = response.data;
                });
            cb(items);
        },
        selectItem(item) {
            this.form.items.push({
                'id': item.id,
                'image': item.image,
                'name': item.name,
                'information': item.information,
                'stock_add': 0
            })
        },
        changeWarehouse() {
            if (this.form.items.length > 0) {
                this.$confirm('Al cambiar de almacén se eliminará los productos de la lista, desea continuar?', 'Advertencia', {
                    confirmButtonText: 'Aceptar',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'
                }).then(() => {
                    this.form.warehouse_id_initial = this.form.warehouse_id
                    this.form.items = [];
                }).catch(() => {
                    this.form.warehouse_id = this.form.warehouse_id_initial
                });
            }
        },
        async onSubmit() {
            if (this.form.items.length === 0) {
                this.$message.error('Debe seleccionar al menos un producto')
                return false;
            }

            if (_.isNull(this.form.observations) || this.form.observations === '') {
                this.$message.error('El campo observaciones es requerido')
                return false;
            }

            let error = false;
            let error_type = false;
            _.forEach(this.form.items, it => {
                if (it.stock_add === '' || it.stock_add === 0) {
                    error = true;
                    return false;
                }
                if (isNaN(it.stock_add)) {
                    error_type = true;
                    return false;
                }
            });

            if (error) {
                this.$message.error('El campo cantidad debe ser válido')
                return false;
            }

            if (error_type) {
                this.$message.error('El campo cantidad es incorrecto')
                return false;
            }


            let warehouse = _.find(this.warehouses, {'id': this.form.warehouse_id});
            this.form.establishment_id = warehouse.establishment_id;

            this.loading = true;
            await this.$http.post(`/${this.resource}`, this.form)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                        this.clickClose()
                        this.$emit('success');
                    } else {
                        this.$message.error(response.data.message)
                    }
                }).catch(error => {
                    console.log(error);
                })
            this.loading = false;
        },
        clickClose() {
            this.$emit('update:showDialog', false)
        }
    }
}
</script>
